import { RunStatus } from '../../../../backend/src/types/types';

export type ProcessingStatus = Extract<
  RunStatus,
  | RunStatus.InQueue
  | RunStatus.Parsing
  | RunStatus.AwaitingApproval
  | RunStatus.Extracting
  | RunStatus.Clustering
  | RunStatus.IdentifyingRelevance
  | RunStatus.IdentifyingInconsistencies
  | RunStatus.Summarising
>;

export const PipelineProcessingStageDescriptions: Record<
  ProcessingStatus,
  { title: string; subTitle: string; description: string }
> = {
  [RunStatus.InQueue]: {
    title: 'In Queue',
    subTitle: 'In Queue...',
    description: 'Your documents are being queued for processing.',
  },
  [RunStatus.Parsing]: {
    title: 'Reading Documents',
    subTitle: 'Calculating pages and completion time.',
    description: 'Converting documents to text and reading them.',
  },
  [RunStatus.AwaitingApproval]: {
    title: '',
    subTitle: '',
    description: '',
  },
  [RunStatus.Extracting]: {
    title: 'Extracting Facts',
    subTitle: 'Extracting facts...',
    description: 'Identifying and extracting facts from documents.',
  },
  [RunStatus.Clustering]: {
    title: 'Clustering Facts',
    subTitle: 'Clustering Facts...',
    description: 'Grouping similar facts to avoid duplication.',
  },
  [RunStatus.IdentifyingRelevance]: {
    title: 'Relevance',
    subTitle: 'Identifying Relevance...',
    description: 'Identifying relevance of facts to overall case.',
  },
  [RunStatus.IdentifyingInconsistencies]: {
    title: 'Inconsistencies',
    subTitle: 'Identifying Inconsistencies...',
    description: 'Identifying inconsistencies across facts.',
  },
  [RunStatus.Summarising]: {
    title: 'Summary',
    subTitle: 'Generating Summary...',
    description: 'Generating summary and identifying case issues.',
  },
};

export const PipelineProcessingStages = Object.keys(PipelineProcessingStageDescriptions) as ProcessingStatus[];

export const isProcessingStatus = (status: RunStatus): status is ProcessingStatus => {
  return PipelineProcessingStages.includes(status as ProcessingStatus);
};
